module.exports = __webpack_public_path__ + "static/media/dangerPin.c4793f58.png";